import { gql } from '@apollo/client';

import type { Session, UserData } from '@cobliteam/common-types';

import { type AccessibleFleetAPI, coblerAttributes, type UserAttributesAPI, type UserPreferencesAPI } from '../../account';
import { accessibleFleetsApiToAccessibeFleets, userAttributesTransformer, userPreferencesTransformer } from '../../account/user/UserTransformer';
import graphQLRequester from '../../request/GraphQLRequester';

class GraphQLUserRequester {
  private queryGetUserData = gql`
    query getUserData($input: UserInput) {
      hasCameraFlag
      userPreferences(input: $input) {
        id
        fleet_id
        user_id
        vehicle_group_ids
        use_vehicles_cluster
        updated_at
        created_at
        onboarding {
          user_id
          fleet_id
          created_at
          started_at
          dismissed_at
          ended_at
          steps {
            step_info {
              depends_on
              step
              skippable
            }
            started_at
            ended_at
            skipped_at
          }
        }
      }
      userAttributes(input: $input) {
        creation_date
        num_devices
      }
      userFleets(input: $input) {
        id
        name
        active
        managers
        user_id
        fleet_id
        role
        groups_restriction
        associated_at
        granted_permissions
      }
    }
  `;

  public getUserData = async ({ session }: { session: Session }) => {
    const response: {
      hasCameraFlag: boolean;
      userPreferences?: UserPreferencesAPI;
      userAttributes: UserAttributesAPI;
      userFleets: AccessibleFleetAPI[];
    } = await graphQLRequester.query({
      query: this.queryGetUserData,
      variables: {
        input: {
          userId: session.user.id,
        },
      },
    });

    const isCobler = session.user.role === 'cobler';

    const userFleets = isCobler && !response.userFleets ? [session.fleet] : accessibleFleetsApiToAccessibeFleets(response.userFleets);

    // transform data
    const userData: UserData = {
      hasCameraFlag: response.hasCameraFlag,
      userPreferences: userPreferencesTransformer(response.userPreferences),
      userAttributes: isCobler ? coblerAttributes : userAttributesTransformer(response.userAttributes),
      userFleets,
    };

    return userData;
  };
}

export default GraphQLUserRequester;
